export default __webpack_public_path__ + "static/media/mas.59532849.svg";